import { Button, Grid } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import { useAlert } from '../../../../../AlertContext';
import { useTranslation } from 'react-i18next';

export default function ScanButton(props: any) {
    const { machineScan, scanButtonText, machineCommand, machineActive, disableScanButton, setScanButtonPressed, scanAndUpload, uploadAndExport, settings } = props
    const { openAlert } = useAlert();
    const { t } = useTranslation();

    const handleClick = () => {
        if (scanAndUpload && uploadAndExport) {
            if (settings.Export.Url.value === "" || settings.Export.Url.value === null) {
                openAlert(
                    t('alertContext.invalidExportUrl.title', 'Invalid Export URL'),
                    t('alertContext.invalidExportUrl.message', 'Please enter a valid URL for export in settings before scanning and uploading.'),
                    t('alertContext.ok', 'Ok'),
                    undefined,
                    false,
                    undefined,
                    { component: 'ScanButton', action: 'validateExportUrl' },
                    'warning'
                );
                return;
            }
        }
        setScanButtonPressed(true);
    }

    const styles = {
        display: {
            display: {
                xs: 'none',
                sm: 'block'
            }
        },
        CircularProgress: {
            mr: 1,
            color: "#FFFFFF"
        }
    }

    if (!machineActive) {
        return (
            <Grid sx={styles.display} item md={11} xs={11} pt={2}>
                <Button className="Scan-Button" disabled={disableScanButton} fullWidth onClick={() => { handleClick() }}> {scanButtonText}</Button>
            </Grid>
        )
    } else {
        return (
            <Grid sx={styles.display} item md={11} xs={11} pt={2}>
                <Button className="Scan-Button Scan-Button-Active" disabled fullWidth onClick={() => { machineScan(`${machineCommand}`) }}><CircularProgress sx={styles.CircularProgress} size={25} /></Button>
            </Grid>
        )
    }
}